<template>
    <v-container fluid class="pa-0">
        <PageHeader :contextStyle="contextStyle">
            <template v-if="( $route.params.lst_id == undefined )" #right>
                <v-btn rounded outlined depressed text @click="downloadItems()" color="primary" class="mr-2 white--text">
                    <v-icon dark>mdi-file-excel</v-icon><span class="hidden-sm-and-down"></span>
                </v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn rounded outlined depressed text @click="modalUpload = true" color="orange" class="mr-2 white--text" v-on="on">
                            <v-icon dark>mdi-cloud-upload</v-icon><span class="hidden-sm-and-down"></span>
                        </v-btn>
                    </template>
                    <span>Injecter des animaux</span>
                </v-tooltip>
                <v-btn small rounded color="primary" @click="initItem" :to="{ name: 'livestocks-edit', params: { lst_id: 0 } }">Ajouter un animal</v-btn>
            </template>
        </PageHeader>
    
        <ItemForm v-if="( $route.params.lst_id !== undefined && parseInt( $route.params.lst_id ) >= 0 )"/>
        <v-card v-else :class="($root.$mobileView) ? 'mt-0 mb-2 ml-0 mr-0 rounded-lg' : 'ma-4 rounded-lg'">
            <ItemsList />
        </v-card>
    
        <!--  Upload livestock file -->
        <v-dialog v-model="modalUpload" max-width="900" >
            <v-card color="grey lighten-4" flat>
                <v-toolbar color="primary" dark class="elevation-2" height="50px">
                    <v-icon class="mr-3">mdi-chevron-down</v-icon>
                    <v-toolbar-title>Importer des animaux</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon color="" @click.native="modalUpload = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                    <v-flex xs6 class="pa-2">
                        <v-file-input ref="livestock" color="orange"
                            @change="getFile($event, 'livestock')" label="Selectionner un fichier"
                            v-model="form.file_livestock">
                        </v-file-input>
                    </v-flex>
                    <v-flex xs4 class="pa-2">
                    </v-flex>
                    <v-flex xs2 class="pa-2">
                        <v-btn color="green" class="mt-3" @click="sendLivestockFile('livestock')" :disabled="(!validUplodlivestock)">Envoyer</v-btn>
                    </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import PageHeader from '@/components/ui/PageHeader'
    import ItemsList  from '@/components/livestocks/LivestockList'
    import ItemForm   from '@/components/livestocks/LivestockForm'
    
    import { mapActions } from 'pinia'
    import { useLivestockStore } from '@/stores/livestock'

    export default {
        name: 'livestocks-page',
        props: ['contextStyle'],
        components: {
            PageHeader,
            ItemsList, ItemForm
        },
        data: function () {
            return {
                modalUpload: false,
                saveProgress: false,
                form: { 
                    file_livestock: null, file_livestock_name: '', file_livestock_source: ''
                },
            }
        },
        computed: {
            validUplodlivestock(){
                return !!this.form.file_livestock;
            }
        },
        created(){},
        mounted: function (){
    
        },
        methods: {
            ...mapActions(useLivestockStore, {initItem: 'RESET_ITEM'}),
            downloadItems(){
                this.$http.customRequest({ method: 'get', url: '/livestocks/xlsxexport/?per_page=false', responseType: 'blob' } )
                    .then( (response) => { this.$download(response.data, "rapport.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                })
            },
        sendLivestockFile(scope){
            // Enregistrement du formulaire
            this.saveProgress = true
            var formFile = new FormData()
            for (var prop in this.form) {
                if( prop == scope ){
                    formFile.append(prop, JSON.stringify( this.form[prop] ))
                } else {
                    formFile.append(prop, this.form[prop])
                }
            }
            if( this.form['file_' + scope] ) {
                formFile.append('file_' + scope, this.form['file_' + scope], this.form['file_' + scope].name)
            }
            this.$http.post( 'livestocks/xlsximport/', formFile ).then( (response) => {
                this.$root.$toast({ color: 'success', text: 'Données enregistrée !' })
                this.saveProgress = false
                this.modalUpload  = false
                for( let prop in response.data ){
                    if( Array.isArray( response.data[prop].error ) ){
                        this.processInfo = response.data[prop].error
                    }
                }
                this.form = { file_livestock: null, file_livestock_name: '', file_livestock_source: '' }
            }).catch( (error) => {
                this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                this.saveProgress = false
                this.modalUpload  = false
                this.form = { file_livestock: null, file_livestock_name: '', file_livestock_source: '' }
            })
        },
        getFile(file, scope){
            const f = Array.isArray(file) ? file[0] : file;
            this.form['file_' + scope + '_name'] = f ? f.name : '';
        },
            
        },
        beforeDestroy() {
    
        },
    }
    </script>